import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from '@emotion/css';
import { Spinner } from '@vp/swan';
const spinnerStyle = css `
    position: absolute;
`;
const progressStyle = css `
    margin: unset;
    position: absolute;
`;
/**
 * Component to show % complete and spinner of the upload progress
 */
export const DrawerThumbailSpinner = (props) => {
    const { uploadProgress, title, showPercent = true } = props;
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: spinnerStyle }, { children: _jsx(Spinner, { size: "super", accessibleText: title, role: "status" }) })), showPercent && _jsx("p", Object.assign({ className: progressStyle, role: "progressbar" }, { children: `${uploadProgress || 0}%` }))] }));
};
DrawerThumbailSpinner.displayName = 'DrawerThumbailSpinner';
//# sourceMappingURL=DrawerThumbnailSpinner.js.map